/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { GUEST_ORDER_FRAGMENT } from '@/order/api/graphql/GuestOrderFragment.graphql';

export const PLACE_NEGOTIABLE_QUOTE_ORDER_FRAGMENT = /* GraphQL */ `
  fragment PLACE_NEGOTIABLE_QUOTE_ORDER_FRAGMENT on PlaceNegotiableQuoteOrderOutputV2 {
    errors {
      code
      message
    }
    order {
      ...GUEST_ORDER_FRAGMENT
    }
  }

  ${GUEST_ORDER_FRAGMENT}
`;
